import {confirmedAlert} from "../component/Alert";
import moment from "moment/moment";
import React from "react";

const HistoryImmunization = ({visit}) => {
    return (
        <div className='card mb-0'>
            <div
                className='card-header bg-success text-white collapsed'
                id={"headinglab-immunization"}
                data-toggle='collapse'
                data-target={"#collapselab-immunization"}
                aria-expanded='false'
                aria-controls={"collapselab-immunization"}
            >
                <h4 className={'mb-0 text-white'}>Riwayat Imunisasi</h4>
            </div>
            <div
                className='collapse'
                id={"collapselab-immunization"}
                aria-labelledby={"headinglab-immunization"}>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-12'>
                            <ul className='list-group shadow'>
                                {visit.immunization_histories.map((item, keys) => {
                                    return (
                                        <li
                                            className='checklist-entry list-group-item align-items-start'
                                            key={keys}>
                                            <div className='d-flex w-100 justify-content-between'>
                                                <div>
                                                    <div className='d-flex w-100 align-items-center'>
                                                        <div className='badge badge-primary'>Imunisasi {item.type.toUpperCase()}</div>
                                                    </div>
                                                </div>
                                                <button onClick={(e) => {
                                                    confirmedAlert(
                                                        "Konfirmasi",
                                                        `Apakah anda akan menghapus data riwayat imunisasi ${item.immunization.name}?`,
                                                        function (confirmed) {
                                                            if (confirmed) {
                                                                delHistory(item.id);
                                                            }
                                                        }
                                                    );
                                                }}
                                                        className='btn btn-outline-danger btn-sm'>
                                                    Hapus</button>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-7'>
                                                    <div className='h3 mb-0'>{'[' + item.immunization.type + '] ' + item.immunization.name}</div>
                                                    <div className='h5'>No: {item.number}</div>
                                                    <div className='text-sm mt-1 mb-1'>{item.description}</div>
                                                    <mark className='text-xs'>Tanggal {moment(item.date).format("DD-MM-YYYY")}</mark>
                                                </div>
                                                <small className='col-md-5 pt-2 text-right text-sm'>
                                                    <div>Oleh: <span className='h5 mb-0'>{item.users.name}</span>
                                                    </div>
                                                    <div>{moment(item.created_at).format("DD-MM-YYYY HH:mm")}</div>
                                                </small>
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HistoryImmunization